import { useState, useMemo, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getDmImei, writeRsCmdSettings } from '../../../../redux/actions';
import Button from "../../../UI/Button/Button";
import Modal from '../../../UI/Modal/Modal'
import '../RsConfig.css'


export default function RsPressure() {
    // Получаем текущее значение параметра из Redux
    const parameter = useSelector((state) => state.dmimei.data[0]);
    const dispatch = useDispatch();

    // Вынесем состояние модалки в контекст или верхний уровень компонента
    const [modalState, setModalState] = useState({
        isOpen: false,
        paramName: '',
        inputValue: '',
        hasError: false,
        currentIndex: null
    });

     // Оптимизированное получение параметров давления
     const pressConf = useMemo(() => [
        parameter?.PMax || '...',
    ], [parameter?.PMax]);

    const nameParam = useMemo(() => [
        "Диапазон датчика давления, Бар",
    ], []);

    // Унифицированный обработчик модального окна
    const handleModalOpen = useCallback((paramName, index) => {
        setModalState({
            isOpen: true,
            paramName,
            inputValue: '',
            hasError: false,
            currentIndex: index
        });
    }, []);

    const handleModalClose = useCallback(() => {
        setModalState(prev => ({ ...prev, isOpen: false }));
    }, []);

    const handleInputChange = useCallback((e) => {
        setModalState(prev => ({ ...prev, inputValue: e.target.value }));
    }, []);

    // Оптимизированная функция сохранения
    const handleSave = useCallback(async () => {
        const { currentIndex, inputValue } = modalState;
        
        if (!inputValue) {
            setModalState(prev => ({ ...prev, hasError: true }));
            return;
        }

        try {
            let value = inputValue.replace(',', '.');
            let processedValue = value;
            
            if (!isNaN(value) && value.trim() !== '') {               
                    processedValue = Math.round(value * 1);
            } else {
                processedValue = pressConf[currentIndex];
            }

            await dispatch(writeRsCmdSettings(parameter?.imei, processedValue, 32 + currentIndex));
            await dispatch(getDmImei(parameter?.imei));

            handleModalClose();
        } catch (error) {
            console.error("Ошибка при сохранении или обновлении данных: ", error);
        }
    }, [modalState, parameter?.imei, parameter?.PMax, pressConf, dispatch, handleModalClose]);

 // Оптимизированный рендеринг параметров
 const PressParametr = useMemo(() => (
    nameParam.map((text, index) => (
        <div className='ParamInput' key={index}> 
            <label>{text}</label> 
            <Button onClick={() => handleModalOpen(text, index)}>
                <span className='buttonInput'>{pressConf[index]}</span>
            </Button> 
        </div>
    ))
), [nameParam, pressConf, handleModalOpen]);

return (
    <div className='cardDm'> 
        <h3>Давление</h3>

        {PressParametr}
         {/* Единое модальное окно */}
         <Modal open={modalState.isOpen}>
                <div className='modalHeader'>
                    <h3>Введите новое значение</h3>
                    <svg onClick={handleModalClose} height="30" viewBox="0 0 200 200" width="30">    
                        <path d="M114,100l49-49a9.9,9.9,0,0,0-14-14L100,86,51,37A9.9,9.9,0,0,0,37,51l49,49L37,149a9.9,9.9,0,0,0,14,14l49-49,49,49a9.9,9.9,0,0,0,14-14Z" />
                    </svg> 
                </div>
                <div className='modalInfo'> 
                    <label className='labelInfo'>{modalState.paramName}</label>
                    <h4 className='labelInfoQuet'>
                        {modalState.hasError ? "Передумали?" : `Желаете установить ${modalState.inputValue}?`}
                    </h4>
                </div>
                <div className='contentControl'>
                    <input 
                        type='number' 
                        className='input' 
                        value={modalState.inputValue} 
                        onChange={handleInputChange}
                        style={{ border: modalState.hasError ? '1px solid red' : null }} 
                    />
                    <div className='modalButton'>
                        <Button onClick={handleModalClose} color="#d2e9d2">Отмена</Button>
                        <Button onClick={handleSave} color="#4bdd4b">Сохранить</Button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}



